/**
 * Pile d'annulation (undo / redo) sur des instantanés de facture.
 *
 * Chaque instantané est une copie profonde : sans cela, Vue continuerait de
 * muter l'objet déjà empilé et « annuler » ne ramènerait nulle part.
 *
 * Le debounce est volontairement laissé à l'appelant (le composant empile au
 * plus une fois par 400 ms) pour garder ce module pur et testable.
 */

export const LIMITE_PAR_DEFAUT = 50

function copier (etat) {
  return etat === null || etat === undefined ? etat : JSON.parse(JSON.stringify(etat))
}

export function creerHistorique (parametres) {
  const limite = (parametres && parametres.limite) || LIMITE_PAR_DEFAUT
  let pile = []
  let position = -1

  return {
    empiler: function (etat) {
      // Une nouvelle modification après une annulation abandonne la branche « refaire »
      if (position < pile.length - 1) {
        pile = pile.slice(0, position + 1)
      }
      pile.push(copier(etat))
      position = pile.length - 1
      if (pile.length > limite) {
        pile.shift()
        position -= 1
      }
    },
    peutAnnuler: function () {
      return position > 0
    },
    peutRefaire: function () {
      return position >= 0 && position < pile.length - 1
    },
    annuler: function () {
      if (position <= 0) return null
      position -= 1
      return copier(pile[position])
    },
    refaire: function () {
      if (position < 0 || position >= pile.length - 1) return null
      position += 1
      return copier(pile[position])
    },
    vider: function () {
      pile = []
      position = -1
    },
    taille: function () {
      return pile.length
    }
  }
}

export default {creerHistorique, LIMITE_PAR_DEFAUT}



// WEBPACK FOOTER //
// ./src/utils/facture/historiqueEdition.js